module.exports = __webpack_public_path__ + "img/150.a5b6c03f.jpg";